<template>
	<div class="sf-datatabe-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">차량판매정보 팝업</th>
							<td class="col-1">
								<el-input v-model="pmcIdInput" @keyup.native.delete="onCarSaleInPutKeyDown()"></el-input>
								<span class="unit input-icon"><i class="icon-sf-search" @click="onCarSalePopup" /></span>
							</td>
							<th class="col-1">부품 선택</th>
							<td class="col-1">
								<el-input v-model="partNoInput" @keyup.native.delete="onPartInPutKeyDown()"></el-input>

								<span class="unit input-icon"><i class="icon-sf-search" @click="onPartPopup" /></span>
							</td>
						</tr>
					</tbody>
				</table>
				<table class="qms-table">
					<tbody>
						<tr>
							<!--업체코드-->
							<th class="col-1">{{ getMessage_('QWCC000950') }}</th>
							<td class="col-1">
								<el-input v-model="cpnyCd" @keyup.native.delete="onCpnyInPutKeyDown()"></el-input>
								<span class="unit input-icon"><i class="icon-sf-search" @click="onCpnyPopup" /></span>
							</td>

							<!--업체명-->
							<th class="col-1">{{ getMessage_('QWCC000951') }}</th>
							<td class="col-1"><el-input v-model="cpnyNm" readonly /></td>
							<!--품번-->
							<th class="col-1">{{ getMessage_('QWCC000956') }}</th>
							<td class="col-1"><el-input v-model="partNo" readonly /></td>
							<!--품명-->
							<th class="col-1">{{ getMessage_('QWCC000957') }}</th>
							<td class="col-1"><el-input v-model="partNm" readonly /></td>
							<!--보증년수-->
							<th class="col-1">{{ getMessage_('QWCC001022') }}</th>
							<td class="col-1"><el-input v-model="usePrd" readonly /></td>
							<!--보증거리-->
							<th class="col-1">{{ getMessage_('QWCC001023') }}</th>
							<td class="col-1"><el-input v-model="milg" readonly /></td>
							<!--분담율-->
							<th class="col-1">{{ getMessage_('QWCC001168') }}</th>
							<td class="col-1"><el-input v-model="rtsh" readonly /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	data() {
		return {
			data: '',
			date1: '',
			input1: '',
			partNoInput: '',
			pmcIdInput: '',
			partScn: 'PT',
			partNo: '',
			cpnyNm: '',
			cpnyCd: '',
			partNm: '',
			usePrd: '',
			milg: '',
			rtsh: ''
		};
	},
	props: {
		scrId: { type: String, default: '' },
		pmcId: { type: String, default: '' },
		sendCpnyParam: { type: Object }
	},
	watch: {
		partNo(newValue, oldValue) {
			this.partNoInput = newValue;
		},
		pmcId(newValue, oldValue) {
			this.pmcIdInput = newValue;
		},
		sendCpnyParam(newValue, oldValue) {
			this.cpnyCd = this.sendCpnyParam.cpnyCd;
			this.cpnyNm = this.sendCpnyParam.cpnyNm;
			this.partNo = this.sendCpnyParam.partNo;
			this.partNm = this.sendCpnyParam.partNm;
			this.usePrd = this.sendCpnyParam.usePrd;
			this.milg = this.sendCpnyParam.milg;
			this.rtsh = this.sendCpnyParam.rtsh;
		}
	},
	async created() {
		this.cpnyCd = this.cpnyPopup.cpnyCd;
		this.cpnyNm = this.cpnyPopup.cpnyNm;
		this.partNo = this.cpnyPopup.partNo;
		this.partNm = this.cpnyPopup.partNm;
		this.usePrd = this.cpnyPopup.usePrd;
		this.milg = this.cpnyPopup.milg;
		this.rtsh = this.cpnyPopup.rtsh;
	},

	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onPartPopup() {
			//popup창 뜨는 이벤트 template에 선언후 정의
			this.$emit('PopupOpen', this.partNoInput);
		},
		onCarSalePopup() {
			//popup창 뜨는 이벤트 template에 선언후 정의
			this.$emit('CarSalePopupOpen', this.pmcIdInput);
		},
		onCpnyPopup() {
			//popup창 뜨는 이벤트 template에 선언후 정의
			//console.log('open시 this.cpnyNm ::: ', this.cpnyNm);
			this.$emit('CpnyPopupOpen', this.cpnyNm);
		},
		onCpnyInPutKeyDown() {
			//지웠을때 실행함
			this.pmcId = '';
			this.cpnyCd = '';
			this.cpnyNm = '';
			this.partNo = '';
			this.partNm = '';
			this.usePrd = '';
			this.milg = '';
			this.rtsh = '';
		},
		onCarSaleInPutKeyDown() {
			//지웠을때 실행함
			this.pmcIdInput = '';
		},
		onPartInPutKeyDown() {
			//지웠을때 실행함
			this.partNoInput = '';
		},
		setProcessInfo() {
			this.cpnyCd = this.cpnyPopup.cpnyCd;
			this.cpnyNm = this.cpnyPopup.cpnyNm;
			this.partNo = this.cpnyPopup.partNo;
			this.partNm = this.cpnyPopup.partNm;
			this.usePrd = this.cpnyPopup.usePrd;
			this.milg = this.cpnyPopup.milg;
			this.rtsh = this.cpnyPopup.rtsh;
		}
	}
};
</script>
